/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);

jQuery_T4NT(document).ready(function($)
{
  var $html					= $("html"),
      $body					= $("body"),
      $window				= $(window),
      $shColorSwatch		= $(".sh-colorswatch"),
      shColorPreview		= document.getElementById("shColorImagePreview"),
      $shColorOutput		= $shColorSwatch.closest("[data-swatch-option]").find("[sh-color-output]"),
      $shColorTiles			= $shColorSwatch.find(".sh-color__item"),
      defaultColorName		= $($shColorTiles[0]).attr("sh-color-name"),
      $shCollectionFilter	= $(".sh-collection__filter"),
      $shPromotionBar		= $("#shopify-section-sh_promobar"),
      $shFaqItem			= $(".sh-faq__item"),
      //$ucBtn				= $("#uc-privacy-button"),
      $shCollectionFilterBar= $(".sh-collection__filterbar"),
      $shCollectionFilterBtn= $(".sh-mobile-filter-btn"),
      $overlay				= $(".t4s-close-overlay"),
      visibleClass			= "is--visible",
      resizeTimer;
  
  function is_touch_device() {
    return 'ontouchstart' in window        // works on most browsers 
    || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  };
  
  var stylaholic = {
    "check_touch": function () {
      if (is_touch_device()) {
        $html.removeClass("no-touch").addClass("touch");
      } else {
        $html.removeClass("touch").addClass("no-touch");
      }
      
      if (Modernizr.touchevents) {
        $html.removeClass("modernizer-no-touch").addClass("modernizer-touch");
      } else {
        $html.removeClass("modernizer-touch").addClass("modernizer-no-touch");
      }
    },
    "hoverProduct": function (e) {
      e.preventDefault(); e.stopPropagation();
      if ( Modernizr.touchevents === false || !is_touch_device() ) {
        if (e.type === "mouseenter") {
          $(e.currentTarget).addClass("is--hover");
        } else {
          $(e.currentTarget).removeClass("is--hover");
        }
      }
    },
    "searchViewAll": function (e) {
      e.preventDefault(); e.stopPropagation();
      var $form = $(e.currentTarget.closest("#t4s-search-hidden").querySelector("form.t4s-mini-search__frm"));
      if ($form.length > 0) {
        $form.submit();
      }
    },
    "changeColorName": function (name) {
      $shColorOutput.text(name);
    },
    "colorPreview__show": function (image) {
      if (shColorPreview && window.isTouch == false) {
        $(shColorPreview).find(".inner").html('<img src="' + image + '">');
        $(shColorPreview).css({"display": "block"});
      }
    },
    "colorPreview__close": function () {
      if (shColorPreview) {
        $(shColorPreview).find(".inner").html("");
        $(shColorPreview).css({"display": "none"});
      }
    },
    "scrollto": function ($target) {
      $("html,body").stop().animate({
        scrollTop: $target.offset().top - 60
      }, 400);
      $target.is("a") && $target.click();
    },
    "filter_dropdown_pos": function ($elements) {
      var maxAllowedX = $body.width() - 24;
      $elements.each(function () {
        var $this = $(this),
            $opener = $($this.find('[data-dropdown-open]')),
            $target = $($this.find('[data-dropdown-wrapper]'));
        if ($target.length > 0) {
          if (($this.offset().left + $target.outerWidth()) > maxAllowedX) {
            $opener.data("position", "bottom-end");
          } else {
            $opener.data("position", "bottom-start");
          }
        }
      });
    }
  }
  
  $(document).on("mouseenter mouseleave", ".sh_product-grid-item", stylaholic.hoverProduct);
  $(document).on("click", "a.t4s-mini-search__viewAll", stylaholic.searchViewAll);
  
  stylaholic.check_touch();
  $window.on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      stylaholic.check_touch();
    }, 250);
  });
  
  /* Usercentrics */
  /*if ($ucBtn.length > 0) {
    $(".copyright_menu").append('<a href="#uc-privacy-button" class="uc-central-trigger"><sapn>Dateneinstellungen</span></a>');
    $body.on("click", ".uc-central-trigger", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $($(this).attr("href")).trigger("click");
    });
  }*/
  
  /* SH Color Tiles */
  $shColorOutput.text(defaultColorName);
  $shColorTiles.mouseenter(function() {
    stylaholic.changeColorName($(this).attr("sh-color-name"));
    if (!$(this).hasClass("active")) {
      stylaholic.colorPreview__show($(this).attr("sh-color-image"));
    }
  });
  $shColorTiles.mouseleave(function() {
    stylaholic.changeColorName(defaultColorName);
    stylaholic.colorPreview__close();
  });
    
  /** Variant selection changed */
  $(document).on("variant:changed", function(event) {
    // event.oldVariant
    // event.currentVariant
    console.log( event.currentVariant );
    stylaholic.changeColorName(defaultColorName);
  });
  /** END */
  
  /** SH Gototab */
  $(document).on("click", ".sh-scrollto", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var selector = $(this).data("selector");
    var target = document.querySelector(selector);
    target && stylaholic.scrollto($(target));
  });
  /** END */
  
  /** SH Dropdown */
  if ($shCollectionFilter.length > 0) {
    stylaholic.filter_dropdown_pos($shCollectionFilter);
    $window.on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        stylaholic.filter_dropdown_pos($shCollectionFilter);
      }, 250);
    });
  }
  /* END **/
  
  /* SH Mobile Filter */
  $body.on("click", ".sh-mobile-filter-btn", function (event) {
    event.preventDefault(); event.stopPropagation();
    var $target = $($(this).data("target"));
    $target.addClass(visibleClass);
  });
  $body.on("click", ".sh-collection__mobilefilter [data-close]", function (event) {
    event.preventDefault(); event.stopPropagation();
    var $this	= $(this),
        $target	= $($this.data("close"));
    if ($target.length > 0) {
      $target.removeClass(visibleClass);
      $target.find(".filter-slide.active .filter-slide__content").css({"animation": ""})
      $target.find(".filter-slide.active").removeClass("t4s-d-flex").removeClass("active");
    }
  });
  $body.on("click", ".filter-slide-trigger", function (event) {
    event.preventDefault(); event.stopPropagation();
    var $this= $(this),
        $target= $($this.data("target"));
    $target.addClass("t4s-d-flex").addClass("active");
    $target.find(".filter-slide__content").css({"animation": "400ms ease-in-out 0ms 1 normal forwards running slideUp"});
  });
  $body.on("click", ".filter-slide__backdrop, .filter-slide__content-header, .filter-slide__content-footer [data-close]", function (event) {
    event.preventDefault(); event.stopPropagation();
    var $this = $(this),
        $slide= $this.closest(".filter-slide");
    $slide.find(".filter-slide__content").css({"animation": "400ms ease-in-out 0ms 1 normal forwards running slideExit"});
    setTimeout(function () {
      $slide.removeClass("active").removeClass("t4s-d-flex");
      $slide.find(".filter-slide__content").css({"animation": ""});
    },500);
  });
  /* END */
  
  /* Promotion Bar */
  if ($shPromotionBar.length > 0) {
    $shPromotionBar.find(".sh-promotion-bar__close").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $shPromotionBar.remove();
    });
  }
  
  /* FAQ */
  if ($shFaqItem.length > 0) {
    $shFaqItem.find(".question").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).parent().toggleClass("is--open");
    });
  }
  
  /** Cleverreach Form */
  var $crForm = $(".cleverreach_form");
  if ($crForm.length > 0) {
    $crForm.each(function () {
      var $form				= $(this),
          $crEmailWrapper	= $form.find('.cr_form-inputgroup--typeemail'),
          $crEmailInput		= $form.find('input[type="email"]'),
          $crSubmitWrapper	= $form.find('.cr_form-component--submit'),
          crErrorClass		= 'clever_form_error',
          crErrorInfoClass	= 'cr_form-errorInfo';
      if (window.location.pathname.indexOf('newsletter-anmeldung') > 0) {
        $form.find('.' + crErrorClass).removeClass(crErrorClass);
        $form.find('.' + crErrorInfoClass).remove();
        $crSubmitWrapper.removeClass('fl_between').addClass('fl_end');
        var pageSearchString = window.location.search;
        if (pageSearchString.indexOf('err=blocked') > -1) {
          $crEmailInput.addClass(crErrorClass);
          $crEmailWrapper.append('<div class="' + crErrorInfoClass + '">Die angegebene E-Mail-Adresse kann nicht verwendet werden!</div>');
        }
        if (pageSearchString.indexOf('err=exists') > -1) {
          $crEmailInput.addClass(crErrorClass);
          $crEmailWrapper.append('<div class="' + crErrorInfoClass + '">Die angegebene E-Mail-Adresse ist bereits eingetragen!</div>');
        }
        if (pageSearchString.indexOf('err=format') > -1) {
          $crEmailInput.addClass(crErrorClass);
          $crEmailWrapper.append('<div class="' + crErrorInfoClass + '">Die angegebene E-Mail-Adresse ist nicht korrekt formatiert!</div>');
        }
        if (pageSearchString.indexOf('err=missing') > -1) {
          $crSubmitWrapper.prepend('<div class="' + crErrorInfoClass + '">Fehlendes Pflichtfeld!</div>');
          $crSubmitWrapper.removeClass('fl_end').addClass('fl_between');
        }
        if (pageSearchString.indexOf('err=captcha') > -1) {
          $form.find('.cr_form-component--captcha').addClass(crErrorClass);
          $crSubmitWrapper.prepend('<div class="' + crErrorInfoClass + '">Fehlendes reCAPTCHA!</div>');
          $crSubmitWrapper.removeClass('fl_end').addClass('fl_between');
        }
      }
      $form.submit(function (event) {
        var $f = $(this),
            ec = 0;
        $f.find("." + crErrorClass).removeClass(crErrorClass);
        $f.find("." + crErrorInfoClass).remove();
        $crSubmitWrapper.removeClass("fl_between").addClass("fl_end");
        $f.find('.musthave').find('input,textarea').each(function() {
          if ($.trim($(this).val())=='' || ($(this).is(':checkbox')) || ($(this).is(':radio'))) {
            if ($(this).is(':checkbox') || $(this).is(':radio')) {
              if (!$(this).parents('.cr_ipe_item').find(':checked').is(':checked')) {
                $(this).parents('.cr_ipe_item').addClass(crErrorClass);
                ec++;
              }
            } else {
              $(this).addClass(crErrorClass);
              if( $(this).hasClass('g-recaptcha-response') ) {
                $f.find('.cr_form-component--captcha').addClass(crErrorClass);
                $crSubmitWrapper.prepend('<div class="' + crErrorInfoClass + '">Fehlendes reCAPTCHA!</div>');
                $crSubmitWrapper.removeClass('fl_end').addClass('fl_between');
              }
              ec++;
            }
          }
        });
        if (ec > 0) {
          return false;
        } else {
          return true;
        }
      });
    });
  }
  
});


